import React, { useMemo } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { useSeo } from '../hooks/useSeo';
import { Hero } from '../components/sections/Hero';
import { TrustBar } from '../components/sections/TrustBar';
import { ServicesGrid } from '../components/sections/ServicesGrid';
import { WhyChoose } from '../components/sections/WhyChoose';
import { ServiceAreasGrid } from '../components/sections/ServiceAreasGrid';
import { ProjectGallery } from '../components/sections/ProjectGallery';
import { About } from '../components/sections/About';
import { Process } from '../components/sections/Process';
import { Testimonials } from '../components/sections/Testimonials';
import { BlogSection } from '../components/sections/BlogSection';
import { CtaBand } from '../components/sections/CtaBand';
import { ContactSection } from '../components/sections/ContactSection';
import { faqSchema, localBusinessSchema } from '../utils/schema';
export function Home({
  showBlog = true
}: {
  showBlog?: boolean;
}) {
  const {
    lang
  } = useLanguage();
  const seo = useMemo(() => lang === 'es' ? {
    title: 'Reparación de Cimientos en Washington | Crawl Space | IG Foundation Systems',
    description: 'Reparación profesional de cimientos, encapsulado de crawl space, impermeabilización de sótanos y aislamiento en todo Washington. Inspecciones gratis. Con licencia y seguro. Llama 360-463-7104.'
  } : {
    title: 'Foundation Repair Washington | Crawl Space Solutions | IG Foundation Systems',
    description: 'Professional foundation repair, crawl space encapsulation, and insulation services across Washington State. Free inspections. Licensed & insured. Call 360-463-7104.'
  }, [lang]);
  const schema = useMemo(() => [localBusinessSchema(), faqSchema([{
    question: 'How much does a foundation inspection cost in Washington?',
    answer: 'Home foundation and crawl space inspections from IG Contracting & Foundation Systems are free, with a written report and photos, typically scheduled within 48 hours.'
  }, {
    question: 'What areas of Washington do you serve?',
    answer: 'We serve Shelton, Seattle, Tacoma, Auburn, Olympia, Federal Way, Kirkland, Aberdeen, Centralia, Montesano, and surrounding Western Washington communities.'
  }, {
    question: 'Do you offer crawl space encapsulation and basement waterproofing?',
    answer: 'Yes. We provide crawl space cleaning and encapsulation, vapor and moisture barrier installation, sump pump systems, and complete basement waterproofing.'
  }, {
    question: 'Is your team bilingual?',
    answer: 'Yes, our team supports customers in both English and Spanish from the first call through final inspection.'
  }])], []);
  useSeo({
    title: seo.title,
    description: seo.description,
    keywords: ['foundation repair Washington', 'crawl space repair near me', 'basement waterproofing Washington', 'insulation installation contractor', 'crawl space encapsulation', 'foundation inspection services', 'foundation repair in Shelton WA'],
    schema
  });
  return <>
      <Hero data-id="element-432" data-mp="3sscc73y8op16" />
      <TrustBar data-id="element-433" data-mp="3sru49a27smdf" />
      <ServicesGrid data-id="element-434" data-mp="3stdlp3zlx3gs" />
      <WhyChoose data-id="element-435" data-mp="3ssvrse0f31c1" />
      <ProjectGallery data-id="element-436" data-mp="3sugdde4r79xr" />
      <Process data-id="element-437" data-mp="3nt975ji9eit7" />
      <About data-id="element-438" data-mp="3ntskso0vml1f" />
      <ServiceAreasGrid data-id="element-439" data-mp="3nuat4j0tcppp" />
      <Testimonials data-id="element-440" data-mp="3nv3q4s9z00un" />
      {showBlog && <BlogSection data-id="element-441" data-mp="5nmosvdl86l3" />}
      <CtaBand data-id="element-442" data-mp="5o5xdlhclimg" />
      <ContactSection data-id="element-443" data-mp="5opb0pzytkuo" />
    </>;
}